export default "__VITE_ASSET__DnNFdTjZ__"